/**
 * @file api/users.js
 * @description API functions for the /api/users resource (admin only).
 */

import apiClient from './client';

/**
 * Fetches all local application users.
 * @returns {Promise<Array>} Array of user objects.
 */
export const listUsers = async () => {
  const res = await apiClient.get('/api/users');
  return res.data;
};

/**
 * Fetches a single user by ID.
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const getUser = async (id) => {
  const res = await apiClient.get(`/api/users/${id}`);
  return res.data;
};

/**
 * Updates a user's role and/or active status.
 * @param {number} id
 * @param {{ role?: 'admin'|'operator'|'viewer', active?: boolean }} payload
 * @returns {Promise<Object>} Updated user record.
 */
export const updateUser = async (id, payload) => {
  const res = await apiClient.put(`/api/users/${id}`, payload);
  return res.data;
};

/**
 * Deactivates a user account (sets active=false).
 * @param {number} id
 * @returns {Promise<Object>} Confirmation message.
 */
export const deactivateUser = async (id) => {
  const res = await apiClient.delete(`/api/users/${id}`);
  return res.data;
};
